function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import withTheme from '../../Theme/withTheme';
import { getPreset, getShimmerOptions } from '../../Theme/selectors';
import Shimmer from '../index';
var ShimmerIcon = function ShimmerIcon(_ref) {
  var className = _ref.className,
    propInline = _ref.inline,
    propPreset = _ref.preset,
    propRadius = _ref.radius,
    propSize = _ref.size,
    style = _ref.style,
    uiTheme = _ref.uiTheme;
  var shimmerOptions = getShimmerOptions(uiTheme, 'icon');
  var defaultInline = shimmerOptions.inline,
    defaultPreset = shimmerOptions.preset,
    defaultRadius = shimmerOptions.radius,
    defaultSize = shimmerOptions.size;
  var presetName = propPreset || defaultPreset;
  var preset = getPreset(uiTheme, 'icon', presetName);
  var typePreset = getPreset(uiTheme, 'typography', presetName);
  var presetSize = preset.size;
  var lineHeight = typePreset.lineHeight;
  var size = propSize || presetSize || defaultSize || 21;
  var radius = propRadius || defaultRadius || 0;
  var inline = propInline || defaultInline || false;
  return /*#__PURE__*/React.createElement(Shimmer, {
    className: className,
    width: size,
    height: size,
    radius: radius,
    style: _objectSpread({
      display: inline ? 'inline-block' : 'block',
      verticalAlign: 'baseline',
      marginTop: (parseInt(lineHeight, 10) - size) / 2,
      marginBottom: (parseInt(lineHeight, 10) - size) / 2
    }, style)
  });
};
ShimmerIcon.defaultProps = {
  className: null,
  inline: null,
  preset: null,
  radius: null,
  size: null,
  style: {},
  uiTheme: {}
};
ShimmerIcon.displayName = 'ShimmerIcon';
export default withTheme(ShimmerIcon);